import * as uuid from "uuid/v1"; // timestamp-based uuid 

export type Severity = "warning" | "error" | "success" | "info"; 

export type Category = "product" | "media" | "export";

export interface StatusMessage
{
    id: string;
    message: string;
    severity: Severity;
    category: Category;
}

export const createStatusMessage = (message: string, severity: Severity, category: Category, id = uuid()): StatusMessage => ({
    id, message, severity, category
});



// WEBPACK FOOTER //
// ./src/state/ui/StatusMessage.ts